import Immutable from 'immutable';

export const UiState = Immutable.fromJS({
    spinnerVisible: false,
});

export const GithubState = Immutable.fromJS({
    userId: '',
    data: {},
});

export const StudentList = Immutable.fromJS({
    data: {}
});

export const FlasMsg = Immutable.fromJS({
    data: {}
});

export const ModalData = Immutable.fromJS({
    modalName: '',
    modalIsOpen: {},
    modalBody: '', // 準備移除
    modalMsg: ''

})

export const TemplateData = Immutable.fromJS({
    title: '1234',
    menuButton: '',
    body: '',
})


export const TeacherProfile = Immutable.fromJS({
    teacher: {},
    role: {},
    isAuthorized: false
})

export const DeviseUser = Immutable.fromJS({
    user_data: {},
    token: ''
})

export const ApplicationForAdmission = Immutable.fromJS({
    data: {}
})

export const TransferStudent = Immutable.fromJS({
    data: {}
})

export const ParentalStatusSurvey = Immutable.fromJS({
    data: {}
})

export const HealthQuestionnaire = Immutable.fromJS({
    data: {}
})

export const ParentPass = Immutable.fromJS({
    data: {}
})

export const BrotherMember = Immutable.fromJS({
    index_data: {},
    data: {}
})
export const FamilyMember = Immutable.fromJS({
    index_data: {},
    data: {}
})





// WEBPACK FOOTER //
// ./src/dashboards_redux/constants/models.jsx